/**
 * The available spacing.
 *
 * Here's the rough guideline.  Customize this for you usage.  It's ok to put exceptions
 * within the components themselves if they are truly exceptions.
 *
 * 0 = none
 * 1 = mini
 * 2 = tiny
 * 3 = small
 * 4 = medium
 * 5 = large
 * 6 = big
 * 7 = huge
 * 8 = massive
 */
export const spacing = {
  none: '0px',
  mini: '5px',
  tiny: '10px',
  small: '20px',
  xmedium: '24px',
  smedium: '30px',
  medium: '40px',
  mLarge: '50px',
  large: '60px',
  standard: '64px',
  big: '80px',
  huge: '100px',
  massive: '120px',
  ultra: '150px',
};

export const componentPaddingX = spacing.small; // fixed
export const componentPaddingY = spacing.small; // fixed
export const componentMarginX = spacing.small; // fixed
export const componentMarginY = spacing.small; // fixed
